/* SwiftMoto: size guide behaviour for the product page Content drawer.
   - cm / in switch: shows columns whose heading says (cm) or (in). Values are
     typed in exactly as the supplier gives them; nothing is converted.
     The switch only appears when the drawer has both units.
   - Fades rows for sizes this product isn't sold in. */
(function () {
  var STORE_KEY = 'sm-size-unit';
  var CM = /\(\s*(cm|centimet(?:re|er)s?)\s*\)/i;
  var IN = /\(\s*(in|in\.|inch|inches)\s*\)/i;

  function getSaved() {
    try { return localStorage.getItem(STORE_KEY); } catch (e) { return null; }
  }
  function save(unit) {
    try { localStorage.setItem(STORE_KEY, unit); } catch (e) {}
  }

  function norm(t) {
    t = String(t).toUpperCase().replace(/\*/g, '').replace(/\s+/g, '').trim();
    t = t.replace(/^T\./, '').replace(/^[WK]-/, '');
    var map = { XXXS: '3XS', XXS: '2XS', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL' };
    return map[t] || t;
  }

  // Work out which columns hold cm or inch values from the heading row
  function columnUnits(headRow) {
    var units = [];
    Array.prototype.forEach.call(headRow.cells, function (cell) {
      var text = cell.textContent;
      var unit = CM.test(text) ? 'cm' : IN.test(text) ? 'in' : '';
      var span = cell.colSpan || 1;
      for (var i = 0; i < span; i++) units.push(unit);
    });
    return units;
  }

  function markRow(row, units) {
    var col = 0;
    Array.prototype.forEach.call(row.cells, function (cell) {
      var unit = units[col];
      if (unit) cell.setAttribute('data-sg-unit', unit);
      col += cell.colSpan || 1;
    });
  }

  function setupTable(table, sizes) {
    var parentClasses = table.parentElement.classList;
    // The theme may already have wrapped the table in a scrolling .table-wrapper
    if (!parentClasses.contains('sg-table-wrap') && !parentClasses.contains('table-wrapper')) {
      var wrap = document.createElement('div');
      wrap.className = 'sg-table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    }
    var rows = Array.prototype.slice.call(table.rows);
    if (!rows.length) return { cm: false, in: false };
    var head = table.tHead && table.tHead.rows[0] ? table.tHead.rows[0] : rows[0];
    head.classList.add('sg-head');
    var units = columnUnits(head);
    var found = { cm: units.indexOf('cm') > -1, in: units.indexOf('in') > -1 };

    var anySold = false;
    var bodyRows = rows.filter(function (r) { return r !== head; });
    bodyRows.forEach(function (row) {
      row.classList.add('sg-row');
      markRow(row, units);
      if (!sizes) return;
      var col = 0, match = false;
      Array.prototype.forEach.call(row.cells, function (cell) {
        if (!units[col]) {
          var text = cell.textContent;
          var candidates = [norm(text)].concat(text.split(/[\s\/,]+/).map(norm));
          for (var i = 0; i < candidates.length; i++) {
            if (candidates[i] && sizes[candidates[i]]) { match = true; break; }
          }
        }
        col += cell.colSpan || 1;
      });
      if (match) { row.classList.add('sg-sold'); anySold = true; }
    });
    // Only fade if at least one row matched, so a naming mismatch never fades everything
    if (anySold) {
      bodyRows.forEach(function (row) {
        if (!row.classList.contains('sg-sold')) row.classList.add('sg-unsold');
      });
    }
    markRow(head, units);
    return found;
  }

  function apply(unit) {
    document.querySelectorAll('.sg-content[data-sg-both]').forEach(function (c) {
      c.setAttribute('data-sg-view', unit);
    });
    document.querySelectorAll('.sg-units button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sg-set') === unit ? 'true' : 'false');
    });
  }

  function setup(drawer) {
    if (drawer.getAttribute('data-sg-ready')) return;
    var content = drawer.querySelector('.sg-content');
    if (!content) return;
    drawer.setAttribute('data-sg-ready', '1');

    var sizes = null;
    var raw = drawer.getAttribute('data-sg-sizes') || '';
    if (raw) {
      sizes = {};
      raw.split('|').forEach(function (v) { if (v) sizes[norm(v)] = true; });
    }

    // Drop empty paragraphs the page editor leaves around tables (they add big gaps)
    content.querySelectorAll('p').forEach(function (para) {
      if (!para.textContent.replace(/\u00a0/g, ' ').trim() && !para.querySelector('img, iframe, video')) {
        para.remove();
      }
    });

    var hasCm = false, hasIn = false;
    content.querySelectorAll('table').forEach(function (table) {
      var f = setupTable(table, sizes);
      hasCm = hasCm || f.cm;
      hasIn = hasIn || f.in;
    });

    var toggle = drawer.querySelector('.sg-units');
    if (hasCm && hasIn) {
      content.setAttribute('data-sg-both', '1');
      if (toggle) {
        toggle.hidden = false;
        toggle.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var unit = b.getAttribute('data-sg-set');
            save(unit);
            apply(unit);
          });
        });
      }
      apply(getSaved() === 'in' ? 'in' : 'cm');
    }
  }

  function init() {
    document.querySelectorAll('content-drawer[data-sg]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
